export const setUnvisitedPlacesNearbyKeyword = ({ keyword }) => state => {
  return {
    ...state,
    unvisitedPlace: {
      ...state.unvisitedPlaces,
      keyword,
      pagination: {
        ...state.unvisitedPlaces.pagination,
        currentPageNumber: 1,
        pageNumber: 1,
      },
    },
  };
};
